export const clearPhone = (phone: string): string => {
  if (!phone) return '';

  let clearPhone: string = phone.replace(/\D/g, '');

  if (clearPhone.startsWith('7')) clearPhone = clearPhone.substr(1);

  return clearPhone;
};
